import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'

import { LicenseInfo } from '@mui/x-license-pro'

LicenseInfo.setLicenseKey(
  '2213d2be68d4323017356ee2f3debfc4T1JERVI6NDI3MjMsRVhQSVJZPTE2ODI3OTM1NzMwMDAsS0VZVkVSU0lPTj0x'
)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
